// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1ok_S","label":"Labeled_label__3AW1I","divider":"Labeled_divider__3G6Sf"};